import { NavLink } from "react-router-dom";
import Faq from "./faq";
import { CONTACT_CONFIG } from '../config/contact';

export default function Reimbursement() {
  const contactInfo = CONTACT_CONFIG;
  return (
    <>
      {/* Header Section */}
      <section className="bg-gradient-to-r from-[#00d4ff] to-[#090979] text-white py-8">
        <div className="h-[25vh]"></div>
        <div className="main-content">
          {/* Main Title */}
          <div className="text-center">
            <h1 className="text-4xl font-bold">Restitutiebeleid</h1>
          </div>
          {/* Navigation Breadcrumbs */}
          <div className="text-center mb-4">
            <span className="text-sm">
              <NavLink
                to="/"
                className="transition-all duration-500 hover:text-[#090979]"
              >
                Home
              </NavLink>{" "}
              /{" "}
              <span className="text-gray-300">Restitutiebeleid</span>
            </span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-slate-50 text-[#1B1B1B] py-12 min-h-[80vh]">
        <div className="main-content w-[85%] m-auto">
          <div className="space-y-8">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                1. Recht op terugbetaling
              </h2>
              <p className="text-base leading-relaxed">
                Bij feesttv doen we er alles aan om uw tevredenheid te garanderen.
                Daarom bieden wij een restitutiebeleid van 15 dagen voor al onze gebruikers.
                Als u om welke reden dan ook niet tevreden bent met onze diensten,
                kunt u binnen 15 dagen na uw aankoop een terugbetaling aanvragen.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                2. Voorwaarden voor terugbetaling
              </h2>
              <p className="text-base leading-relaxed">
                Om in aanmerking te komen voor een terugbetaling, moet aan de volgende voorwaarden worden voldaan:
              </p>
              <ul className="list-disc list-inside pt-2 space-y-1">
                <li>
                  Het verzoek moet binnen 15 dagen na de aankoopdatum worden ingediend.
                </li>
                <li>
                  U moet een geldig aankoopbewijs overleggen, zoals uw ontvangstbewijs of bevestigingsmail.
                </li>
                <li>
                  Terugbetalingen zijn niet beschikbaar als u al meer dan 50% van uw abonnementsperiode heeft gebruikt.
                </li>
              </ul>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                3. Aanvraagprocedure
              </h2>
              <p className="text-base leading-relaxed">
                Volg deze stappen om een terugbetaling aan te vragen:
              </p>
              <ol className="list-inside list-decimal pt-2 space-y-1">
                <li>
                  Neem contact op met ons ondersteuningsteam via WhatsApp of e-mail.
                </li>
                <li>
                  Vermeld uw bestelnummer en de reden voor het verzoek.
                </li>
                <li>
                  Voeg het aankoopbewijs toe (ontvangstbewijs of bevestigingsmail).
                </li>
              </ol>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                4. Terugbetalingsmethode
              </h2>
              <p className="text-base leading-relaxed">
                Als uw terugbetalingsverzoek wordt goedgekeurd, wordt het bedrag
                terugbetaald via dezelfde betaalmethode die u voor uw aankoop heeft gebruikt.
                De verwerkingstijd kan variëren afhankelijk van uw betaalprovider.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">5. Neem contact met ons op</h2>
              <p className="text-base leading-relaxed mb-4">
                Voor vragen over dit restitutiebeleid of om uw rechten uit te oefenen,
                kunt u contact met ons opnemen via:
              </p>
              <ul className="list-disc list-inside space-y-2 text-base">
                <li>E-mail: {contactInfo.email}</li>
                <li>
                  WhatsApp:{" "}
                  <a
                    href={contactInfo.whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#00d4ff] underline hover:text-[#090979]"
                  >
                    Klik hier om contact met ons op te nemen
                  </a>
                </li>
              </ul>
            </div>

            {/* Conclusion */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-base leading-relaxed">
                Bedankt dat u voor {contactInfo.companyName} heeft gekozen. Wij zijn er trots op
                uw privacy te waarborgen en u een hoogwaardige service te bieden.
              </p>
            </div>
          </div>
        </div>
        <Faq />
      </section>
    </>
  );
}
